import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-dollar-sign',
  templateUrl: './dollar-sign.component.html',
  styleUrls: ['./dollar-sign.component.scss']
})
export class DollarSignComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
